<template>
  <main>
    <v-content>
      <v-container fluid>
        <v-layout column align-center>
          <div class="display-3 grey--text text--darken-1 mt-5">Seite leider nicht gefunden</div>
          <div class="body-2 my-3">
            <router-link :to="{ name: 'startseite' }" exact="">
             <v-btn large color="accent">Zurück zur Startseite</v-btn>
            </router-link>
            <!-- response:status-code=404 -->
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script>
export default {
  comments: true,
  name: 'not-found',
  layout: 'default',
  metaInfo () {
    // eslint-disable-next-line no-labels
    meta: [
      ' <!-- response:status-code=404 -->'
    ]
  }
}

</script>
